import { useEffect, useMemo, useState } from "react";
import trans, { isRTL } from "../../../../../utils";
import AntdTable from "../../../../antd/Table/Table";
import { useSelector } from "react-redux";
import { useGetAllUsersQuery } from "../../../../../Redux/service/Users/AuthUsers";
import { Tag } from "antd";

export default function TotalUsersTable({ limit, query, setLimit, setQuery }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState({
    by: "",
    order: "",
  });

  const inf = useSelector((state) => state.users.user);

  useEffect(() => {
    setCurrentPage(1);
  }, [query]);

  useEffect(() => {
    localStorage.setItem("page", 1);
  }, []);

  const {
    data: allUsers,
    isLoading,
    isError,
  } = useGetAllUsersQuery(
    {
      userId: inf.id,
      page: currentPage,
      limit: limit,
      search: query,
      sortby: sort.by,
      sortorder: sort.order,
    },
    {
      skip: !inf.id || !currentPage || !limit,
    },
  );

  useEffect(() => {
    localStorage.setItem("page", 1);
  }, [setQuery]);

  const role = (user) => {
    if (
      (user?.adminstrator === false || user?.deviceReadonly === false) &&
      (user?.userLimit > 0 || user?.userLimit === -1)
    ) {
      return trans("Manager");
    } else if (user?.deviceReadonly) {
      return trans("Fleet Operator");
    } else if (user?.readonly) {
      return trans("Fleet Observer");
    } else if (user?.userLimit === 0 && user?.deviceLimit === 0) {
      return trans("Fleet Observer");
    } else if (user?.adminstrator === true) {
      return trans("Admin");
    } else {
      return "- - - - -";
    }
  };

  useEffect(() => {
    if (
      allUsers?.totalCount &&
      currentPage > Math.ceil(allUsers.totalCount / limit)
    ) {
      setCurrentPage(1);
    }
  }, [allUsers?.totalCount]);

  const columns = [
    {
      title: trans("Name"),
      dataIndex: "name",
      width: 150,
      fixed: !isRTL ? "left" : undefined,
      sorter: true,
      render: (value) => (
        <span className={"table-element-name ps-0"}>{value}</span>
      ),
    },
    {
      title: trans("phone number"),
      dataIndex: "phone",
      sorter: true,
      width: 150,
      render: (value) => value || "- - - - -",
    },
    {
      title: trans("Email"),
      dataIndex: "email",
      sorter: true,
      width: 150,
      render: (value) => value || "- - - - -",
    },
    {
      title: trans("role"),
      dataIndex: "administrator",
      width: 150,
      render: (_, record) => (
        <Tag color="blue">{record?.role?.name || "-"}</Tag>
      ),
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      setSort({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      setSort({
        by: "",
        order: "",
      });
    }
  };

  return (
    <div className="mt-3 table-parent">
      <AntdTable
        columns={columns}
        dataSource={allUsers?.data || []}
        loading={isLoading}
        pageSize={limit}
        totalItems={allUsers?.totalCount || 0}
        currentPage={currentPage}
        onPageChange={(page) => {
          setCurrentPage(page);
          localStorage.setItem("page", page);
        }}
        onLimitChange={(newLimit) => {
          setLimit(newLimit);
          setCurrentPage(1);
        }}
        scrollY={300}
        onTableChange={handleTableChange}
      />
    </div>
  );
}
